import { Theme, Typography, alpha, makeStyles } from "@material-ui/core"
import { Alert, AlertTitle } from "@material-ui/lab"
import { MaterialSymbol } from "../../hour-reporting-roles/components/MaterialSymbol"
import type { HourReportingAdminsTranslations } from "../hooks/use-translations"

type AdminInfoBannerProps = {
  translations: HourReportingAdminsTranslations
}

export const AdminInfoBanner = ({ translations }: AdminInfoBannerProps) => {
  const classes = useStyles()

  return (
    <Alert
      severity="warning"
      variant="outlined"
      icon={<MaterialSymbol name="admin_panel_settings" />}
      className={classes.root}
    >
      <AlertTitle>{translations.infoTitle}</AlertTitle>
      <Typography variant="body2">{translations.infoDescription}</Typography>
    </Alert>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: alpha(theme.palette.warning.main, 0.08),
    "& .MuiAlert-icon": {
      color: theme.palette.warning.dark,
    },
  },
}))
